/* CASA COTON — Page coffret (/pages/coffrets/<handle>)
 * Fichier : assets/cc-coffret-page.js (vanilla, chargé uniquement sur les pages coffret)
 * Données : <script type="application/json" data-ccp-data> rendu par sections/casa-coffret-page.liquid
 *
 * Une couleur pour tout le coffret, choisie en tête de la liste des articles : elle change les photos
 * (assemblage du haut + vignettes). La taille se choisit par un bouton « Choisir la taille » sur la ligne
 * de chaque article qui en a plusieurs (fenêtre) ; le premier choix se propage aux autres articles à taille
 * (« 3 mois » vaut « 0 - 3 mois »). Un seul prénom, saisi dans une fenêtre depuis la ligne « Broderie »,
 * brodé sur toutes les pièces personnalisables (chacune l'indique sous son titre).
 * Broderie OPTIONNELLE (18/09) : dans la fenêtre, le client saisit le prénom, choisit la couleur du fil (Bleu / Rose /
* Blanc / Marron, aucune présélection) et COCHE les pièces à broder (aucune cochée par défaut). Sans sélection, le coffret
* s'ajoute au panier sans aucune broderie. Seules les pièces cochées reçoivent la propriété « Broderie » et une ligne de frais.
* Prix : pas de remise en % ; la broderie est OFFERTE (ligne de frais à 0 € : variante « Offerte (coffret) »),
 * sa valeur normale est affichée barrée et cumulée en bas. Livraison affichée comme une ligne « Offert ».
 * Aucun prénom n'est envoyé aux outils de mesure.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ccp]');
  if (!root) return;
  var dataEl = root.querySelector('[data-ccp-data]');
  if (!dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var C = DATA.coffret;
  var S = DATA.strings || {};
  if (!C || !C.products || !C.products.length) return;

  /* ---------------------------------------------------------------- utilitaires */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    cents = Math.round(cents);
    var neg = cents < 0; cents = Math.abs(cents);
    var dec = String(cents % 100); if (dec.length < 2) dec = '0' + dec;
    return (neg ? '-' : '') + String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + dec + ' €';
  }
  function norm(v) {
    v = String(v || '').toLowerCase().trim();
    try { v = v.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return v.replace(/œ/g, 'oe').replace(/[-_\/.]/g, ' ').replace(/\s+/g, ' ').trim().replace(/ /g, '-');
  }
  function nums(v) { return (String(v).match(/\d+/g) || []).map(Number); }
  function tpl(str, map) { return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function floorC(x) { return Math.floor(x + 1e-9); }
  function store(key, val) { try { if (val === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null'); sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; } }
  function param(n) { try { return new URLSearchParams(location.search).get(n); } catch (e) { return null; } }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function scrollTo(el) { if (!el) return; window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 110, behavior: reduced() ? 'auto' : 'smooth' }); }
  function byId(pid) { pid = parseInt(pid, 10); return C.products.filter(function (x) { return x.id === pid; })[0] || null; }

  /* ---------------------------------------------------------------- UTM + tracking */
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var utm = store('ccf:utm') || {};
  (function () { var f = {}, any = false; UTM.forEach(function (k) { var v = param(k); if (v) { f[k] = String(v).slice(0, 120); any = true; } }); if (any) { utm = f; store('ccf:utm', utm); } })();
  var fired = {};
  function track(name, extra, once) {
    if (once && fired[once]) return; if (once) fired[once] = true;
    var pr = pricing();
    var p = Object.assign({ currency: DATA.currency || 'EUR', bundle_id: C.handle, bundle_name: C.title, bundle_value: +(pr.bundle / 100).toFixed(2), bundle_saving: +(pr.saving / 100).toFixed(2), product_count: C.products.length, embroidery_count: pr.embCount, embroidery_value: +(pr.emb / 100).toFixed(2), total_value: +(pr.total / 100).toFixed(2), personalized: pr.embCount > 0 }, extra || {});
    UTM.forEach(function (k) { if (utm[k]) p[k] = utm[k]; });
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, p); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, p)); } catch (e) {}
  }

  /* ---------------------------------------------------------------- modèle */
  var PCT = C.pct || 0;
  var embOn = !!(C.embroidery_available);
  function embItem(p) { return embOn && p.embroidery && p.embroidery.eligible && p.embroidery.fee_variant; }
// Pièce effectivement brodée : éligible, cochée par le client, prénom saisi et fil choisi
function embChosen(p) { return !!(embItem(p) && state.embSel[p.id] && state.name.trim() && state.thread); }
function embChosenList() { return C.products.filter(embChosen); }
  var embItems = C.products.filter(embItem);
  function hasChoice(p, idx) { return idx >= 0 && !p.has_only_default_variant && p.options[idx] && p.options[idx].values.length > 1; }
  function colorVals(p) { return p.color_index >= 0 && p.options[p.color_index] ? p.options[p.color_index].values : []; }
  function sizeVals(p) { return p.size_index >= 0 && p.options[p.size_index] ? p.options[p.size_index].values : []; }

  // Couleurs proposées en tête de liste : celles de la première pièce qui offre un vrai choix de couleur
  var refColor = C.products.filter(function (p) { return hasChoice(p, p.color_index); })[0] || null;
  var colorValues = refColor ? colorVals(refColor).slice() : [];
  // Couleur imposee par le coffret : une seule valeur, donc plus de ligne « Couleur » dans la liste
  if (C.forced_color) {
    var fcMatch = colorValues.filter(function (v) { return norm(v) === norm(C.forced_color); });
    colorValues = fcMatch.length ? fcMatch : [C.forced_color];
  }
  // Couleur commune par défaut (même règle que l'assemblage côté serveur) : celle que le plus de pièces possèdent
  function commonColor() {
    var best = null, bn = -1;
    colorValues.forEach(function (v) {
      var n = C.products.filter(function (p) { return colorVals(p).some(function (x) { return norm(x) === norm(v); }); }).length;
      if (n > bn) { bn = n; best = v; }
    });
    return best;
  }
  // Fils : communs à toutes les pièces brodées si possible, sinon tous
  var threads = [];
  if (embItems.length) {
    var lists = embItems.map(function (p) { return p.embroidery.threads || []; });
    var inter = lists[0].filter(function (t) { return lists.every(function (l) { return l.some(function (x) { return x.name === t.name; }); }); });
    threads = inter.length ? inter : lists.reduce(function (acc, l) { l.forEach(function (t) { if (!acc.some(function (x) { return x.name === t.name; })) acc.push(t); }); return acc; }, []);
  }

  var state = { color: null, sizes: {}, sizesUser: {}, ownColor: {}, other: {}, name: '', thread: '', embSel: {}, started: false, nameEntered: false };
  (function restore() {
    var sv = store('ccp:' + C.handle) || {};
    state.color = (sv.color && colorValues.indexOf(sv.color) > -1) ? sv.color : commonColor();
    state.sizes = sv.sizes || {}; state.sizesUser = sv.sizesUser || {}; state.ownColor = sv.ownColor || {}; state.other = sv.other || {};
    // Broderie : jamais restaurée d'une visite précédente (aucune case cochée, aucun fil présélectionné à l'ouverture)
    state.name = ''; state.thread = ''; state.embSel = {};
    state.started = !!sv.started;
  })();
  function save() { store('ccp:' + C.handle, { color: state.color, sizes: state.sizes, sizesUser: state.sizesUser, ownColor: state.ownColor, other: state.other, started: state.started }); }

  // Couleur d'une pièce : sa seule couleur, sinon son choix propre, sinon la couleur du coffret si elle l'a
  function colorFor(p) {
    var vals = colorVals(p);
    if (!vals.length) return null;
    if (vals.length === 1) return vals[0];
    var own = state.ownColor[p.id];
    if (!C.forced_color && own && vals.indexOf(own) > -1) return own;
    if (state.color == null) return null;
    return vals.filter(function (v) { return norm(v) === norm(state.color); })[0] || null;
  }
  // Taille d'une pièce : sa seule taille, sinon celle choisie sur sa ligne
  function sizeFor(p) {
    var vals = sizeVals(p);
    if (!vals.length) return null;
    if (vals.length === 1) return vals[0];
    var s = state.sizes[p.id];
    return (s && vals.indexOf(s) > -1) ? s : null;
  }
  // Taille équivalente dans une autre pièce : exacte, sinon par les nombres (« 3 mois » → « 0 - 3 mois »)
  function matchSize(p, chosen) {
    var vals = sizeVals(p);
    if (chosen == null) return null;
    var exact = vals.filter(function (v) { return norm(v) === norm(chosen); })[0];
    if (exact) return exact;
    var t = nums(chosen);
    if (t.length) {
      var last = t[t.length - 1];
      var cands = vals.filter(function (v) { return nums(v).indexOf(last) > -1; });
      if (cands.length) { var same = cands.filter(function (v) { var c = nums(v); return c[c.length - 1] === last; }); return same[0] || cands[0]; }
    }
    return null;
  }
  function variantOf(p, sel) {
    if (p.has_only_default_variant) return p.variants[0] || null;
    for (var i = 0; i < sel.length; i++) if (sel[i] == null) return null;
    return p.variants.filter(function (v) { return v.options.every(function (o, j) { return o === sel[j]; }); })[0] || null;
  }
  function resolve(p) {
    var sel = p.options.map(function (o, i) {
      if (i === p.size_index) return sizeFor(p);
      if (i === p.color_index) return colorFor(p);
      return o.values.length === 1 ? o.values[0] : ((state.other[p.id] || {})['o' + i] || null);
    });
    if (p.has_only_default_variant) sel = [p.variants[0] ? p.variants[0].options[0] : 'Default Title'];
    var v = variantOf(p, sel);
    // La pièce a-t-elle besoin de son propre choix de couleur ? Quand la couleur du coffret ne lui convient pas
    // (elle ne l'a pas, ou plus aucune taille disponible dans cette couleur), ou s'il n'y a pas de choix global.
    var needColor = false;
    // Couleur imposée par le coffret : jamais de choix de couleur par pièce
    if (!C.forced_color && p.available && hasChoice(p, p.color_index)) {
      var c = colorFor(p);
      if (c == null) needColor = (state.color != null || colorValues.length < 2);
      else if (!p.variants.some(function (x) { return x.available && x.options[p.color_index] === c; })) needColor = true;
    }
    return { sel: sel, variant: v, ok: !!(v && v.available), needColor: needColor };
  }
  // État d'une taille pour une pièce, dans sa couleur courante
  function sizeState(p, val) {
    var c = colorFor(p), si = p.size_index, ci = p.color_index;
    var fits = function (x) { return x.options[si] === val && (ci < 0 || c == null || x.options[ci] === c); };
    if (!p.variants.some(fits)) return 'none';
    return p.variants.some(function (x) { return x.available && fits(x); }) ? 'ok' : 'soldout';
  }
  // Une couleur du coffret est-elle possible ? (au moins une pièce la propose en stock)
  function colorState(value) {
    return C.products.some(function (p) {
      if (!hasChoice(p, p.color_index)) return false;
      var mapped = colorVals(p).filter(function (v) { return norm(v) === norm(value); })[0];
      if (!mapped) return false;
      var sz = sizeFor(p);
      return p.variants.some(function (x) { return x.available && x.options[p.color_index] === mapped && (p.size_index < 0 || sz == null || x.options[p.size_index] === sz); });
    }) ? 'ok' : 'none';
  }
  function itemPrice(p, r) { if (r.variant) return r.variant.price; var m = null; p.variants.forEach(function (v) { if (v.available && (m == null || v.price < m)) m = v.price; }); return m == null ? (p.variants[0] ? p.variants[0].price : 0) : m; }
  // Prix : articles au prix normal ; broderie facturée fee_price (0 € quand elle est offerte), valeur normale fee_value
  function pricing() {
    var out = { value: 0, saving: 0, bundle: 0, emb: 0, embFull: 0, embCount: 0, total: 0, full: 0, allOk: true, lines: [] };
    C.products.forEach(function (p) {
      var r = resolve(p);
      var price = itemPrice(p, r);
      var e = embChosen(p);
      out.value += price;
      if (e) { var paid = p.embroidery.fee_price || 0, val = p.embroidery.fee_value || paid; out.emb += paid; out.embFull += val; out.embCount++; }
      if (!r.ok) out.allOk = false;
      out.lines.push({ p: p, r: r, price: price, alloc: 0, net: price, emb: e });
    });
    out.saving = out.embFull - out.emb;
    out.bundle = out.value;
    out.total = out.value + out.emb;
    out.full = out.value + out.embFull;
    out.gift = out.embCount > 0 && out.emb === 0 && out.embFull > 0;
    // 04/10/2026 (demande Precilia) : la valeur barrée et la remise comptent TOUTES les broderies offertes du coffret
    // (pièces brodables x valeur normale), cochées ou non. Le prix payé ne change pas.
    var freeVal = 0, freeN = 0;
    embItems.forEach(function (p) { var e = p.embroidery || {}; if ((e.fee_price || 0) === 0 && e.fee_value) { freeVal += e.fee_value; freeN++; } });
    if (freeVal > out.saving) { out.full += freeVal - out.saving; out.embFull += freeVal - out.saving; out.saving = freeVal; out.gift = true; }
    out.embOfferN = freeN;
    // Livraison standard offerte au-dessus du seuil : sa valeur (DATA.ship_price) est comptée dans la valeur barrée
    var sth = shipThreshold(), sp = DATA.ship_price || 0;
    out.ship = (sp > 0 && (!sth || out.total >= sth)) ? sp : 0;
    out.savingAll = out.saving + out.ship;
    out.fullAll = out.full + out.ship;
    return out;
  }
  function threadFor(p) {
    var t = (p.embroidery && p.embroidery.threads) || [];
    var hit = t.filter(function (x) { return x.name === state.thread; })[0];
    return hit ? hit.name : (t[0] ? t[0].name : '');
  }
  function shipThreshold() { var bar = document.querySelector('[data-cc-ship]'); var th = bar ? parseInt(bar.getAttribute('data-threshold'), 10) : 0; return isNaN(th) ? 0 : th; }

  /* ---------------------------------------------------------------- médias */
  function mediaById(p, id) { return p.media.filter(function (m) { return m.id === id; })[0] || null; }
  function mediaFor(p, colorValue) {
    var cn = norm(colorValue || '');
    var list = [];
    if (cn) list = p.media.filter(function (m) { return m.color === cn; });
    var v = null;
    if (colorValue && p.color_index >= 0) v = p.variants.filter(function (x) { return norm(x.options[p.color_index]) === cn && x.media_id; })[0];
    if (v) { var vm = mediaById(p, v.media_id); if (vm && list.indexOf(vm) < 0) list.unshift(vm); }
    p.media.forEach(function (m) { if (!m.color && list.indexOf(m) < 0) list.push(m); });
    // Aucune photo de cette couleur ni générique : repli sur toutes les photos (jamais de visionneuse vide)
    if (!list.length) p.media.forEach(function (m) { if (list.indexOf(m) < 0) list.push(m); });
    return list;
  }
  // Photo « couleur » d'une valeur : première pièce ayant une photo marquée ou une photo de variante dans cette couleur
  function colorSwatch(v) {
    for (var i = 0; i < C.products.length; i++) {
      var p = C.products[i];
      if (p.color_index < 0) continue;
      var mine = colorVals(p).filter(function (x) { return norm(x) === norm(v); })[0];
      if (!mine) continue;
      var lst = mediaFor(p, mine);
      if (lst.length && (lst[0].color === norm(mine) || p.variants.some(function (x) { return x.media_id === lst[0].id && norm(x.options[p.color_index]) === norm(mine); }))) return lst[0];
    }
    return null;
  }
  // L'assemblage du haut suit la couleur choisie
  function updateCollage() {
    $$('[data-cc-collage] [data-pid]').forEach(function (cell) {
      var p = byId(cell.getAttribute('data-pid'));
      if (!p || p.color_index < 0) return;
      var c = colorFor(p);
      if (!c) return;
      var m = mediaFor(p, c)[0];
      var img = cell.querySelector('img');
      if (!m || !img) return;
      if (img.getAttribute('data-src') === m.src) return;
      img.setAttribute('data-src', m.src);
      var pre = new Image();
      pre.onload = function () { if (img.getAttribute('data-src') !== m.src) return; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = m.src; img.alt = m.alt || p.title; };
      pre.src = m.src;
    });
  }

  /* ---------------------------------------------------------------- rendu */
  var els = { items: $('[data-ccp-items]'), err: $('[data-ccp-err]'), total: $('[data-ccp-total]'), price: $('[data-ccp-price]'), add: $('[data-ccp-add]'), sticky: $('[data-ccp-sticky]'), stickyPrice: $('[data-ccp-sticky-price]'), stickyAdd: $('[data-ccp-sticky-add]'), done: $('[data-ccp-done]'), doneSub: $('[data-ccp-done-sub]'), pop: $('[data-ccp-pop]') };
  var needle = '<span class="ccp__needle" aria-hidden="true">\u{1F9F5}</span>';
  var truck = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  var gift = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9"/><path d="M2.5 7.5h19v4.5h-19z"/><path d="M12 21.5V7.5"/><path d="M12 7.5H7.75a2.375 2.375 0 1 1 0-4.75C11 2.75 12 7.5 12 7.5Z"/><path d="M12 7.5h4.25a2.375 2.375 0 1 0 0-4.75C13 2.75 12 7.5 12 7.5Z"/></svg>';
  function priceCell(net, full) { return '<span class="ccp__item-price"><b>' + money(net) + '</b>' + (full > net ? '<s>' + money(full) + '</s>' : '') + '</span>'; }
  // Les articles d'un coffret sont compris dans son prix : « Inclus » puis le prix a titre indicatif
  function inclCell(net) { return '<span class="ccp__item-price ccp__item-price--inc"><b>' + esc(S.included || 'Inclus') + '</b><span class="ccp__item-was">' + money(net) + '</span></span>'; }
  function giftCell(full) { return '<span class="ccp__item-price"><b class="ccp__free">' + esc(S.free) + '</b>' + (full > 0 ? '<s>' + money(full) + '</s>' : '') + '</span>'; }

  function renderItems() {
    var pr = pricing();
    var html = '';
    // 1) la couleur du coffret, en tête de liste
    if (colorValues.length > 1) {
      html += '<li class="ccp__row ccp__row--color"><span class="ccp__lbl">' + esc(S.color) + (state.color ? '<b> : ' + esc(state.color) + '</b>' : '') + '</span><span class="ccp__chips" role="group" aria-label="' + esc(S.color) + '">';
      colorValues.forEach(function (v) {
        var st = colorState(v), m = colorSwatch(v);
        html += '<button type="button" class="ccp__chip ccp__chip--color' + (m ? ' has-img' : '') + '" data-ccp-color="' + esc(v) + '" aria-pressed="' + (state.color === v ? 'true' : 'false') + '"' + (st !== 'ok' ? ' aria-disabled="true"' : '') + '>' + (m ? '<img src="' + esc(m.thumb) + '" alt="" width="56" height="56" loading="lazy">' : '') + '<span>' + esc(v) + '</span></button>';
      });
      html += '</span><span class="ccp__field-err" data-ccp-ferr="color" hidden></span></li>';
    }
    // 2) les articles
    pr.lines.forEach(function (l) {
      var p = l.p, r = l.r;
      var m = mediaFor(p, colorFor(p))[0];
      var meta = [];
      if (!p.has_only_default_variant) p.options.forEach(function (o, i) { if (i !== p.size_index && r.sel[i]) meta.push(r.sel[i]); });
      var sz = sizeFor(p), sized = hasChoice(p, p.size_index);
      if (sz && !sized) meta.unshift(sz);
      html += '<li class="ccp__item' + (r.needColor ? ' ccp__item--own' : '') + (!p.available ? ' ccp__item--sold' : '') + '" data-ccp-item="' + p.id + '">';
      html += '<button type="button" class="ccp__thumb" data-ccp-zoom="' + p.id + '" aria-label="' + esc(S.photos) + ' : ' + esc(p.title) + '">' + (m ? '<img src="' + esc(m.thumb) + '" width="80" height="80" alt="' + esc(m.alt) + '">' : '') + '<span class="ccp__thumb-zoom" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2M11 8v6M8 11h6"/></svg></span></button>';
      html += '<span class="ccp__item-body"><span class="ccp__item-title">' + esc(p.title) + '</span>';
      if (l.emb && state.name.trim()) html += '<span class="ccp__item-gift">' + needle + esc(tpl(S.item_emb_name, { name: state.name.trim() })) + '</span>';
      if (meta.length) html += '<span class="ccp__item-meta">' + esc(meta.join(' · ')) + '</span>';
      if (!p.available) html += '<span class="ccp__item-warn">' + esc(S.sold_out) + '</span>';
      if (r.needColor) html += renderOwnColor(p);
      if (p.available && sized) html += renderSize(p, sz);
      if (p.available) html += renderOther(p, r);
      html += '</span>';
      html += inclCell(l.price);
      html += '</li>';
    });
    // 3) la broderie, comme un article
    if (embItems.length) {
      var nm = state.name.trim(), chosen = embChosenList(), isSet = chosen.length > 0;
      html += '<li class="ccp__item ccp__item--emb' + (isSet ? ' is-set' : '') + '" data-ccp-emb-row>';
      html += '<span class="ccp__thumb ccp__thumb--emb ccp__thumb--needle" aria-hidden="true">\u{1F9F5}</span>';
      html += '<span class="ccp__item-body"><span class="ccp__item-title">' + esc(S.emb_title) + ' <span class="ccp__item-opt">' + esc(S.emb_optional || 'en option') + '</span></span>';
      if (isSet) html += '<span class="ccp__item-meta ccp__item-meta--name">' + needle + '<span class="ccp__item-name">' + esc(nm) + '</span><span class="ccp__item-thread">· ' + esc(S.thread_short) + ' ' + esc(state.thread) + ' · ' + chosen.length + ' ' + esc(chosen.length > 1 ? (S.pieces || 'pièces') : (S.piece || 'pièce')) + '</span></span>';
      else html += '<span class="ccp__item-meta">' + esc(S.emb_hint || '') + '</span>';
      html += '<span class="ccp__own"><button type="button" class="ccp__chip ccp__chip--sm ccp__chip--act" data-ccp-open-name>' + esc(isSet ? S.edit_name : S.add_name) + '</button></span>';
      html += '<span class="ccp__field-err" data-ccp-ferr="name" hidden></span>';
      html += '</span>';
      if (isSet) html += pr.gift ? giftCell(pr.embFull) : priceCell(pr.emb, pr.embFull);
      else html += '<span class="ccp__item-price"><b class="ccp__free">' + esc(S.free) + '</b></span>';
      html += '</li>';
    }
    // 4) la livraison, comme un article
    var th = shipThreshold(), free = !th || pr.total >= th;
    html += '<li class="ccp__item ccp__item--ship">';
    html += '<span class="ccp__thumb ccp__thumb--emb" aria-hidden="true">' + truck + '</span>';
    html += '<span class="ccp__item-body"><span class="ccp__item-title">' + esc(S.ship_title) + '</span>';
    var shipMeta = free ? S.ship_meta_ok : tpl(S.ship_meta_left, { m: money(th - pr.total) });
    if (shipMeta) html += '<span class="ccp__item-meta">' + esc(shipMeta) + '</span>';
    html += '</span>';
    html += '<span class="ccp__item-price">' + (free ? '<b class="ccp__free">' + esc(S.ship_free) + ' <span class="cc-fren">en<span class="cc-fr" role="img" aria-label="France"></span></span></b>' + (pr.ship > 0 ? '<s>' + money(pr.ship) + '</s>' : '') : '<span class="ccp__item-mute">' + esc(S.ship_paid) + '</span>') + '</span>';
    html += '</li>';
    els.items.innerHTML = html;
  }
  function renderOwnColor(p) {
    var vals = colorVals(p), cur = colorFor(p);
    var html = '<span class="ccp__own"><span class="ccp__own-lbl">' + esc(S.own_color) + '</span><span class="ccp__chips">';
    vals.forEach(function (v) {
      var avail = p.variants.some(function (x) { return x.available && x.options[p.color_index] === v; });
      html += '<button type="button" class="ccp__chip ccp__chip--sm" data-ccp-own-color="' + p.id + '" data-val="' + esc(v) + '" aria-pressed="' + (cur === v ? 'true' : 'false') + '"' + (!avail ? ' aria-disabled="true"' : '') + '>' + esc(v) + '</button>';
    });
    return html + '</span></span>';
  }
  // Bouton « Choisir la taille » (ouvre la fenêtre des tailles de la pièce) ; une fois choisie : « Taille : 3 mois »
  function renderSize(p, cur) {
    var html = '<span class="ccp__own ccp__own--size"><button type="button" class="ccp__chip ccp__chip--sm' + (cur ? ' ccp__chip--set' : ' ccp__chip--act') + '" data-ccp-open-size="' + p.id + '" aria-haspopup="dialog">' + (cur ? esc(S.size) + ' : <b>' + esc(cur) + '</b>' : esc(S.choose_size)) + '</button>';
    return html + '<span class="ccp__field-err" data-ccp-ferr="size-' + p.id + '" hidden></span></span>';
  }
  function sizeChips(p) {
    var cur = sizeFor(p), html = '';
    sizeVals(p).forEach(function (v) {
      var st = sizeState(p, v);
      if (st === 'none') return;
      html += '<button type="button" class="ccp__chip" data-ccp-size="' + p.id + '" data-val="' + esc(v) + '" aria-pressed="' + (cur === v ? 'true' : 'false') + '"' + (st !== 'ok' ? ' aria-disabled="true"' : '') + '>' + esc(v) + (st !== 'ok' ? '<span class="visually-hidden"> ' + esc(S.sold_out) + '</span>' : '') + '</button>';
    });
    return html;
  }
  // Autres options (ni taille ni couleur) avec plusieurs valeurs : petit choix sur la ligne
  function renderOther(p, r) {
    var html = '';
    if (p.has_only_default_variant) return html;
    p.options.forEach(function (o, i) {
      if (i === p.size_index || i === p.color_index || o.values.length < 2) return;
      html += '<span class="ccp__own"><span class="ccp__own-lbl">' + esc(o.name) + '</span><span class="ccp__chips">';
      o.values.forEach(function (v) {
        var fits = function (x) { return x.options.every(function (ov, j) { if (j === i) return ov === v; return r.sel[j] == null || ov === r.sel[j]; }); };
        if (!p.variants.some(fits)) return;
        var avail = p.variants.some(function (x) { return x.available && fits(x); });
        html += '<button type="button" class="ccp__chip ccp__chip--sm" data-ccp-other="' + p.id + '" data-idx="' + i + '" data-val="' + esc(v) + '" aria-pressed="' + (r.sel[i] === v ? 'true' : 'false') + '"' + (!avail ? ' aria-disabled="true"' : '') + '>' + esc(v) + '</button>';
      });
      html += '</span></span>';
    });
    return html;
  }
  function valueLabel(pr) { return S.value_sep || 'Valeur'; }
  function renderTotal() {
    var pr = pricing();
    var html = '<dl class="ccp__sum">';
    if (pr.savingAll > 0) {
      html += '<div><dt>' + esc(valueLabel(pr)) + '</dt><dd><s>' + money(pr.fullAll) + '</s></dd></div>';
            if (pr.saving > 0) html += '<div class="ccp__sum-save"><dt>' + needle + esc(S.saving || 'Broderie offerte') + '</dt><dd>−' + money(pr.saving) + '</dd></div>';
      if (pr.ship > 0) html += '<div class="ccp__sum-save ccp__sum-save--ship"><dt>' + truck + esc(S.ship_saving) + '</dt><dd>−' + money(pr.ship) + '</dd></div>';
    } else if (pr.emb > 0) {
      html += '<div><dt>' + esc(S.value_items) + '</dt><dd>' + money(pr.value) + '</dd></div>';
      html += '<div><dt>' + esc(S.emb_title) + '</dt><dd>+' + money(pr.emb) + '</dd></div>';
    }
    html += '<div class="ccp__sum-total"><dt>' + esc(pr.savingAll > 0 ? (S.bundle_price || 'Prix du coffret') : S.total) + '</dt><dd>' + money(pr.total) + '</dd></div></dl>';
    els.total.innerHTML = html;
    if (els.price) els.price.innerHTML = '<span class="ccp__now">' + money(pr.total) + '</span>' + (pr.savingAll > 0 ? '<s class="ccp__was">' + money(pr.fullAll) + '</s><span class="ccp__pct">' + esc(pr.saving > 0 && pr.ship > 0 ? S.gift_badge_ship : (pr.ship > 0 ? S.ship_saving : S.gift_badge)) + '</span>' : '');
    var g = $('[data-ccp-gift]'); if (g) g.hidden = !pr.gift;
    if (els.stickyPrice) els.stickyPrice.textContent = money(pr.total);
    if (!adding) els.add.textContent = S.cta + ' · ' + money(pr.total);
  }
  function renderAll() { renderItems(); renderTotal(); updateCollage(); }
  function refresh() { renderAll(); save(); }

  /* ---------------------------------------------------------------- erreurs */
  function fieldErr(name, msg) { var el = $('[data-ccp-ferr="' + name + '"]'); if (el) { el.textContent = msg || ''; el.hidden = !msg; } }
  function globalErr(msg) { if (els.err) { els.err.textContent = msg || ''; els.err.hidden = !msg; } }
  function clearErrs() { $$('[data-ccp-ferr]').forEach(function (e) { e.hidden = true; e.textContent = ''; }); globalErr(''); $$('.ccp__item.is-error, .ccp__row.is-error').forEach(function (i) { i.classList.remove('is-error'); }); }
  function validate() {
    clearErrs();
    var pr = pricing();
    if (C.products.some(function (p) { return !p.available; })) { globalErr(S.unavailable); return false; }
    if (colorValues.length > 1 && state.color == null) { var row = $('.ccp__row--color'); if (row) row.classList.add('is-error'); fieldErr('color', S.err_color); scrollTo(row); return false; }
    for (var i = 0; i < pr.lines.length; i++) {
      var l = pr.lines[i], li = $('[data-ccp-item="' + l.p.id + '"]');
      if (hasChoice(l.p, l.p.size_index) && sizeFor(l.p) == null) { if (li) li.classList.add('is-error'); fieldErr('size-' + l.p.id, tpl(S.err_size, { p: l.p.title })); scrollTo(li); return false; }
      if (!l.r.ok) {
        if (li) li.classList.add('is-error');
        globalErr(l.r.variant && !l.r.variant.available ? tpl(S.err_sold, { p: l.p.title }) : tpl(S.err_item, { p: l.p.title }));
        scrollTo(li); return false;
      }
    }
    // Broderie optionnelle : aucune contrainte d'ajout au panier liée au prénom ou aux pièces à broder
    return true;
  }

  /* ---------------------------------------------------------------- interactions */
  function started() { if (!state.started) { state.started = true; track('bundle_start', {}, 'start'); } }
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-ccp-color]');
    if (c) {
      if (c.getAttribute('aria-disabled') === 'true') return;
      started();
      state.color = c.getAttribute('data-ccp-color');
      state.ownColor = {};
      track('bundle_variant_selected', { option_name: 'color', option_value: state.color });
      refresh(); return;
    }
    var oc = e.target.closest('[data-ccp-own-color]');
    if (oc) {
      if (oc.getAttribute('aria-disabled') === 'true') return;
      started();
      state.ownColor[oc.getAttribute('data-ccp-own-color')] = oc.getAttribute('data-val');
      refresh(); return;
    }
    var sz = e.target.closest('[data-ccp-size]');
    if (sz) {
      if (sz.getAttribute('aria-disabled') === 'true') return;
      started();
      var pid = sz.getAttribute('data-ccp-size'), val = sz.getAttribute('data-val');
      state.sizes[pid] = val; state.sizesUser[pid] = true;
      // le premier choix se propage aux autres pièces à taille que l'on n'a pas encore réglées soi-même
      C.products.forEach(function (p) {
        if (String(p.id) === String(pid) || !hasChoice(p, p.size_index) || state.sizesUser[p.id]) return;
        var mv = matchSize(p, val);
        if (mv && sizeState(p, mv) === 'ok') state.sizes[p.id] = mv;
      });
      track('bundle_variant_selected', { option_name: 'size', option_value: val, product_id: parseInt(pid, 10) });
      closeSizePop();
      refresh(); return;
    }
    var os = e.target.closest('[data-ccp-open-size]');
    if (os) { openSizePop(os.getAttribute('data-ccp-open-size')); return; }
    if (e.target.closest('[data-ccp-pop-size-close]')) { closeSizePop(); return; }
    var ot = e.target.closest('[data-ccp-other]');
    if (ot) {
      if (ot.getAttribute('aria-disabled') === 'true') return;
      started();
      var op = ot.getAttribute('data-ccp-other');
      state.other[op] = state.other[op] || {}; state.other[op]['o' + ot.getAttribute('data-idx')] = ot.getAttribute('data-val');
      refresh(); return;
    }
    if (e.target.closest('[data-ccp-open-name]')) { openPop(); return; }
    if (e.target.closest('[data-ccp-pop-ok]')) { popOk(); return; }
    if (e.target.closest('[data-ccp-pop-none]')) { popNone(); return; }
    if (e.target.closest('[data-ccp-pop-close]')) { closePop(); return; }
    var t = e.target.closest('[data-ccp-thread]');
    if (t) { $$('[data-ccp-thread]').forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); }); fieldErr('pop-thread', ''); return; }
    var z = e.target.closest('[data-ccp-zoom]');
    if (z) { openLb(parseInt(z.getAttribute('data-ccp-zoom'), 10)); return; }
    if (e.target.closest('[data-ccp-add]') || e.target.closest('[data-ccp-sticky-add]')) { addToCart(); return; }
    if (e.target.closest('[data-ccp-done-close]')) { hideDone(); return; }
    if (e.target.closest('[data-ccp-lb-close]')) { closeLb(); return; }
    if (e.target.closest('[data-ccp-lb-prev]')) { lbStep(-1); return; }
    if (e.target.closest('[data-ccp-lb-next]')) { lbStep(1); return; }
    var th = e.target.closest('[data-ccp-lb-thumb]');
    if (th) { lbShow(parseInt(th.getAttribute('data-ccp-lb-thumb'), 10)); }
  });
  root.addEventListener('input', function (e) { if (e.target.matches('[data-ccp-pop-name]')) fieldErr('pop', ''); });
  root.addEventListener('change', function (e) { var c = e.target.closest('[data-ccp-emb-item]'); if (c) { var l = c.closest('.ccp-pop__item'); if (l) l.classList.toggle('is-on', c.checked); fieldErr('pop-items', ''); } });
  root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-ccp-pop-name]')) { e.preventDefault(); popOk(); } });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLb(); hideDone(); closePop(); closeSizePop(); }
    if (els.lb && !els.lb.hidden) { if (e.key === 'ArrowLeft') lbStep(-1); if (e.key === 'ArrowRight') lbStep(1); }
  });

  /* ---------------------------------------------------------------- fenêtre prénom */
  var popLast = null;
  function openPop() {
    if (!els.pop) return;
    started();
    popLast = document.activeElement;
    var inp = $('[data-ccp-pop-name]'); if (inp) inp.value = state.name;
    // Couleur du fil : aucune présélection, le client choisit parmi la palette (Bleu / Rose / Blanc / Marron)
    var tw = $('[data-ccp-pop-threads]');
    if (tw) {
      tw.innerHTML = threads.length ? '<span class="ccp__threads" role="group" aria-label="' + esc(S.thread) + '">' + threads.map(function (t) { return '<button type="button" class="ccp__thread" data-ccp-thread="' + esc(t.name) + '" aria-pressed="' + (state.thread === t.name ? 'true' : 'false') + '" title="' + esc(t.name) + '"><span class="ccp__thread-dot" style="background:' + esc(t.hex) + '"></span><span class="ccp__thread-name">' + esc(t.name) + '</span></button>'; }).join('') + '</span>' : '';
    }
    // Pièces à broder : une case par pièce personnalisable, AUCUNE cochée par défaut (seuls les choix déjà validés par le client sont rappelés)
    var iw = $('[data-ccp-pop-items]');
    if (iw) {
      iw.innerHTML = embItems.map(function (p) {
        var m = mediaFor(p, colorFor(p))[0];
        var on = !!state.embSel[p.id];
        return '<label class="ccp-pop__item' + (on ? ' is-on' : '') + '"><input type="checkbox" class="ccp-pop__check" data-ccp-emb-item="' + p.id + '"' + (on ? ' checked' : '') + '><span class="ccp-pop__box" aria-hidden="true"><svg viewBox="0 0 14 11"><path d="M1.5 5.5 5 9 12.5 1.5"/></svg></span>' + (m ? '<img class="ccp-pop__img" src="' + esc(m.thumb) + '" alt="" width="44" height="44" loading="lazy">' : '') + '<span class="ccp-pop__item-title">' + esc(p.title) + '</span></label>';
      }).join('');
    }
    fieldErr('pop', ''); fieldErr('pop-thread', ''); fieldErr('pop-items', '');
    els.pop.hidden = false;
    document.documentElement.classList.add('ccp-modal-open');
    if (els.sticky) els.sticky.hidden = true;
    setTimeout(function () { if (inp) try { inp.focus({ preventScroll: true }); } catch (e) {} }, 60);
    track('embroidery_enabled', { count: embItems.length }, 'emb');
  }
  function popOk() {
    var inp = $('[data-ccp-pop-name]');
    var v = inp ? inp.value.replace(/\s+/g, ' ').trim().slice(0, 12) : '';
    var pressed = $('[data-ccp-pop-threads] [data-ccp-thread][aria-pressed="true"]');
    var newThread = pressed ? pressed.getAttribute('data-ccp-thread') : '';
    var checked = $$('[data-ccp-pop-items] [data-ccp-emb-item]:checked').map(function (c) { return c.getAttribute('data-ccp-emb-item'); });
    fieldErr('pop', ''); fieldErr('pop-thread', ''); fieldErr('pop-items', '');
    // Rien de renseigné : le coffret part sans broderie
    if (!v && !checked.length) { popNone(); return; }
    if (!v) { fieldErr('pop', S.err_name); if (inp) try { inp.focus(); } catch (e) {} return; }
    if (!checked.length) { fieldErr('pop-items', S.err_items || 'Cochez au moins une pièce à broder, ou choisissez « Sans broderie ».'); return; }
    if (!newThread) { fieldErr('pop-thread', S.err_thread || 'Choisissez la couleur du fil.'); return; }
    if (newThread !== state.thread) { state.thread = newThread; track('embroidery_thread_selected', { thread_color: state.thread }); }
    state.name = v;
    state.embSel = {};
    checked.forEach(function (id) { state.embSel[id] = true; });
    if (!state.nameEntered) { state.nameEntered = true; track('embroidery_name_entered', { name_length: v.length }); }
    track('embroidery_items_selected', { count: checked.length });
    closePop();
    refresh();
    clearErrs();
  }
  // « Sans broderie » : tout est effacé, le coffret s'ajoute sans personnalisation
  function popNone() {
    state.name = ''; state.thread = ''; state.embSel = {};
    closePop();
    refresh();
    clearErrs();
  }
  function closePop() {
    if (!els.pop || els.pop.hidden) return;
    els.pop.hidden = true;
    document.documentElement.classList.remove('ccp-modal-open');
    if (popLast && popLast.focus) try { popLast.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------------------------------------------------------------- fenêtre taille */
  els.sizePop = $('[data-ccp-pop-size]');
  var sizeLast = null;
  function openSizePop(pid) {
    var p = byId(pid);
    if (!p || !els.sizePop) return;
    started();
    sizeLast = document.activeElement;
    var t = $('[data-ccp-pop-size-title]'); if (t) t.textContent = tpl(S.size_pop_title, { p: p.title });
    var c = $('[data-ccp-pop-size-chips]'); if (c) c.innerHTML = sizeChips(p);
    var cl = colorFor(p); var m = $('[data-ccp-pop-size-meta]'); if (m) m.textContent = cl ? tpl(S.size_pop_meta, { c: cl }) : '';
    els.sizePop.hidden = false;
    document.documentElement.classList.add('ccp-modal-open');
    if (els.sticky) els.sticky.hidden = true;
    setTimeout(function () { var f = $('[data-ccp-pop-size-chips] [aria-pressed="true"]') || $('[data-ccp-pop-size-chips] button'); if (f) try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeSizePop() {
    if (!els.sizePop || els.sizePop.hidden) return;
    els.sizePop.hidden = true;
    document.documentElement.classList.remove('ccp-modal-open');
    if (sizeLast && sizeLast.focus) try { sizeLast.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------------------------------------------------------------- visionneuse */
  els.lb = $('[data-ccp-lb]');
  var lb = { list: [], i: 0, last: null };
  function openLb(pid) {
    var p = byId(pid);
    if (!p || !els.lb) return;
    lb.list = mediaFor(p, colorFor(p));
    if (!lb.list.length) return;
    lb.last = document.activeElement;
    $('[data-ccp-lb-title]').textContent = p.title;
    var th = $('[data-ccp-lb-thumbs]');
    th.innerHTML = lb.list.length > 1 ? lb.list.map(function (m, i) { return '<button type="button" class="ccp-lb__thumb" data-ccp-lb-thumb="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(m.thumb) + '" alt="" width="64" height="64"></button>'; }).join('') : '';
    els.lb.hidden = false;
    document.documentElement.classList.add('ccp-modal-open');
    lbShow(0);
    setTimeout(function () { var c = $('[data-ccp-lb-close]', els.lb); if (c) c.focus(); }, 30);
    track('bundle_photo_zoom', { product_id: pid });
  }
  function lbShow(i) {
    if (!lb.list.length) return;
    lb.i = (i + lb.list.length) % lb.list.length;
    var img = $('[data-ccp-lb-img]');
    img.src = lb.list[lb.i].src; img.alt = lb.list[lb.i].alt || '';
    $$('[data-ccp-lb-thumb]').forEach(function (b, j) { b.setAttribute('aria-current', j === lb.i ? 'true' : 'false'); });
    $$('.ccp-lb__nav').forEach(function (b) { b.hidden = lb.list.length < 2; });
  }
  function lbStep(d) { lbShow(lb.i + d); }
  function closeLb() {
    if (!els.lb || els.lb.hidden) return;
    els.lb.hidden = true;
    document.documentElement.classList.remove('ccp-modal-open');
    if (lb.last && lb.last.focus) try { lb.last.focus({ preventScroll: true }); } catch (e) {}
  }
  // Balayage au doigt
  (function () {
    var x0 = null;
    root.addEventListener('touchstart', function (e) { if (els.lb && !els.lb.hidden) x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) lbStep(dx < 0 ? 1 : -1); }, { passive: true });
  })();

  /* ---------------------------------------------------------------- sticky mobile */
  (function () {
    if (!els.sticky || !('IntersectionObserver' in window)) return;
    var ctaVisible = true, infoInView = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.target === els.add) ctaVisible = en.isIntersecting; if (en.target === root) infoInView = en.isIntersecting; });
      var show = infoInView && !ctaVisible && (!els.done || els.done.hidden) && (!els.lb || els.lb.hidden) && (!els.pop || els.pop.hidden) && (!els.sizePop || els.sizePop.hidden);
      els.sticky.hidden = !show;
      document.body.classList.toggle('cc-sticky-on', show);
    }, { threshold: 0 });
    io.observe(els.add); io.observe(root);
  })();

  /* ---------------------------------------------------------------- ajout au panier */
  var adding = false;
  function buildItems(inst) {
    var items = [];
    var name = state.name.trim();
    // Récapitulatif lisible pour la préparation : posé sur la PREMIÈRE pièce du coffret
    var chosen = embChosenList();
    var summary = chosen.length ? ('Prénom ' + name + ' · Fil ' + state.thread + ' · Articles à broder : ' + chosen.map(function (p) { return p.title; }).join(', ')) : 'Sans broderie';
    C.products.forEach(function (p, idx) {
      var r = resolve(p);
      var props = { 'Coffret': C.title, '_bundle_id': C.handle, '_bundle_name': C.title, '_bundle_instance': inst };
      if (idx === 0) props['Broderie du coffret'] = summary;
      var e = embChosen(p);
      var thread = e ? threadFor(p) : '';
      if (e) { props['Broderie'] = 'Prénom « ' + name + ' »' + (thread ? ' · Fil ' + thread : ''); props['_broderie'] = 'oui'; props['_brd_fee'] = String(p.embroidery.fee_variant); }
      items.push({ id: r.variant.id, quantity: 1, properties: props });
      if (e) {
        var fee = { 'Article': p.title, 'Prénom': name };
        if (thread) fee['Couleur du fil'] = thread;
        fee['_cc_for'] = r.variant.id + '|' + name + '|' + thread + '|' + inst;
        fee['Coffret'] = C.title; fee['_bundle_id'] = C.handle; fee['_bundle_instance'] = inst;
        items.push({ id: p.embroidery.fee_variant, quantity: 1, properties: fee });
      }
    });
    return items;
  }
  function rootUrl() { return DATA.root || '/'; }
  function refreshAvailability(done) {
    var pending = C.products.length;
    C.products.forEach(function (p) {
      fetch(rootUrl() + 'products/' + p.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (pj) {
        if (pj && pj.variants) { p.available = !!pj.available; p.variants.forEach(function (v) { pj.variants.forEach(function (fv) { if (fv.id === v.id) { v.available = !!fv.available; v.price = fv.price; } }); }); }
      }).catch(function () {}).then(function () { if (--pending === 0) done(); });
    });
  }
  function addToCart() {
    if (adding) return;
    if (!validate()) return;
    adding = true;
    var pr = pricing();
    [els.add, els.stickyAdd].forEach(function (b) { if (b) { b.setAttribute('aria-disabled', 'true'); b.classList.add('is-loading'); } });
    els.add.textContent = S.adding;
    var inst = 'cf' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ items: buildItems(inst), sections: 'cart-icon-bubble', sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        if (res.status >= 400 || (res.body && res.body.status >= 400)) { var err = new Error('add'); err.stock = res.status === 422 || (res.body && res.body.status === 422); throw err; }
        try { var sec = res.body.sections && res.body.sections['cart-icon-bubble']; var bubble = document.getElementById('cart-icon-bubble'); if (sec && bubble) { var dom = new DOMParser().parseFromString(sec, 'text/html'); var fresh = dom.getElementById('cart-icon-bubble') || dom.body.firstElementChild; if (fresh) bubble.innerHTML = fresh.innerHTML; } } catch (e) {}
        // Origine de la visite (UTM) écrite dans la commande ; aucun code de réduction : la broderie est offerte par sa variante à 0 €
        var body = {};
        if (utm.utm_source || utm.utm_campaign) body.attributes = { '_cc_utm': [utm.utm_source || '', utm.utm_medium || '', utm.utm_campaign || '', utm.utm_content || ''].join(' / ') };
        if (!body.attributes) return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        return fetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        track('bundle_add_to_cart', { bundle_instance: inst });
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cc-coffret', cartData: cart }); } catch (e) {}
        try { if (typeof window.ccShipRefresh === 'function') window.ccShipRefresh(); } catch (e) {}
        showDone(pr);
      })
      .catch(function (err) {
        if (err && err.stock) refreshAvailability(function () { renderAll(); globalErr(S.err_stock); }); else globalErr(S.err_add);
      })
      .then(function () {
        adding = false;
        [els.add, els.stickyAdd].forEach(function (b) { if (b) { b.removeAttribute('aria-disabled'); b.classList.remove('is-loading'); } });
        renderTotal();
      });
  }
  var doneLast = null;
  function showDone(pr) {
    if (!els.done) { location.href = DATA.cart_url || '/cart'; return; }
    doneLast = document.activeElement;
    if (els.doneSub) els.doneSub.textContent = tpl(S.done_sub, { title: C.title, total: money(pr.total) });
    els.done.hidden = false;
    document.documentElement.classList.add('ccp-modal-open');
    if (els.sticky) els.sticky.hidden = true;
    setTimeout(function () { var a = $('.ccp-done__card a', els.done); if (a) a.focus(); }, 40);
  }
  function hideDone() {
    if (!els.done || els.done.hidden) return;
    els.done.hidden = true;
    document.documentElement.classList.remove('ccp-modal-open');
    if (doneLast && doneLast.focus) try { doneLast.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------------------------------------------------------------- démarrage */
  root.classList.add('ccp--js');
  renderAll();
  track('bundle_view', { landing: location.pathname, deep_link: true }, 'view');
  track('bundle_select', { method: 'page' }, 'select');
  window.addEventListener('pageshow', function (e) { if (e.persisted) renderAll(); });
})();
